// extracted by mini-css-extract-plugin
module.exports = {"container":"_1tvV6l2E3FGd8-JevzS8Bk"};